import React, {
    useRef,
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react';
import type {
    TAssessmentItem,
    TPreviewQuestion,
} from 'types/operation';
import QuestionFrom, { IQuestionFrom } from 'pages/operation/TextVisitEmbeddableWorkflows/components/QuestionFrom';
import commonTabS from 'styles/common.tab.less';

type IProps = {
    goLiveObj: TAssessmentItem;
    onSuccess: (item: Partial<TAssessmentItem>) => void;
    onPreview: (item: TPreviewQuestion) => void;
};

export interface IQuestionManagement {
    validateAndSubmit: () => boolean;
}

const QuestionManagement = forwardRef<IQuestionManagement, IProps>((props, ref) => {
    const { goLiveObj, onSuccess, onPreview } = props;
    const QuestionFromRef = useRef<IQuestionFrom>(null);
    const [previewQuestionFromItem, setPreviewQuestionFromItem] =
        useState<TPreviewQuestion>({} as TPreviewQuestion);

    const handlePreview = (item: TPreviewQuestion) => {
        if (item.type === 'questionFrom') {
            const params = {
                ...item,
                questionsPreviewLink: (item.questionsFormLink || '').replace(
                    '/edit',
                    '/viewform',
                ),
            };
            setPreviewQuestionFromItem(params);
            onPreview(params);
        }
    };

    useImperativeHandle(ref, () => ({
        validateAndSubmit: () => {
            return (
                QuestionFromRef.current?.validateAndSubmit() || false
            );
        },
    }));
    return (
        <div className={commonTabS.content}>
            <QuestionFrom
                item={goLiveObj}
                onSuccess={onSuccess}
                onPreview={handlePreview}
            />
        </div>
    );
});

export default QuestionManagement;
